import { AfterViewInit, Component, ElementRef, Input, OnInit } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { ToastService } from '@app/core/services/toast.service';
import { GridStack } from 'gridstack';
import { BaseWidget, NgCompInputs } from 'gridstack/dist/angular';

@Component({
    selector: 'tt-my-page-custom-widget',
    templateUrl: './my-page-custom-widget.component.html',
    styleUrls: ['./my-page-custom-widget.component.css'],
})
export class MyPageCustomWidgetComponent extends BaseWidget implements OnInit, AfterViewInit {
    public override serialize(): NgCompInputs | undefined {
        return this.context ? { node: this.context } : undefined;
    }

    @Input()
    context!: { api: () => GridStack | undefined };

    public get?: MyPageGet;

    public stateParams: { labour_no: string };

    public saving = false;

    constructor(public elementRef: ElementRef, private datatask: DataTaskService, state: StateService, private modal: ModalService, private toast: ToastService) {
        super();
        this.stateParams = { labour_no: state.getStateParams()['labour_no'] };
    }

    public async save() {
        this.saving = true;

        try {
            const { errorcode, errormessage } = (await this.datatask.Post(3819, this.get))[0];

            if (errorcode !== '0') {
                this.modal.show({ type: 'warning', title: 'error', translateTitle: true, message: errormessage });
            } else {
                this.toast.addToast({
                    id: `mypgage.save.${Date.now()}`,
                    type: 'success',
                    title: 'saved!',
                    translateTitle: true,
                    message: 'changes_have_been_saved',
                    translateMessage: true,
                });
            }
        } finally {
            this.saving = false;
        }
    }

    private async loadGet() {
        this.get = (await this.datatask.Post(3818, this.stateParams))[0];
        setTimeout(() => this.resizeAndCompactColumnsPosition()); // wait things to render and then resize
    }

    ngOnInit(): void {
        this.loadGet();
    }

    /**
     * Resizes this widget to its content and moves around on the other tiles to make sure every thing is compact.
     */
    private resizeAndCompactColumnsPosition() {
        this.context.api?.()?.resizeToContent(this.elementRef.nativeElement.parentElement.parentElement);
        this.context.api?.()?.onResize(document.body.clientWidth);
    }

    ngAfterViewInit(): void {
        this.resizeAndCompactColumnsPosition();
    }
}

interface MyPageGet {
    labour_no: `${number}`;
    labour_name: string;
    relatives_name: string;
    relatives_telephone: string;
}
